<template>
	<GitDiffFileContainer :renderAsList="renderAsList">

		<template v-slot:options>	   
			<template v-for="option in options[file.type]" >
				<input 
					:key="`input-${serviceIndex}-${folderIndex}-${fileIndex}-${option.value}`"
					type="radio"
					class="btn-check"
					:name="`input-${serviceIndex}-${folderIndex}-${fileIndex}`"
					:id="`input-${serviceIndex}-${folderIndex}-${fileIndex}-${option.value}`"
					autocomplete="off"
					:value="option.value"
					:checked="file.selectedOption===option.value"
					@change="onSelectedOptionChange($event, file)"
					v-on:keydown="keyDown($event, file)"
				>
				<label 
					:key="`label-${serviceIndex}-${folderIndex}-${fileIndex}-${option.value}`" 
					class="btn btn-pill"
					:class="file.selectedOption===option.value ? option.class : 'btn-outline-gray'"  
					:for="`input-${serviceIndex}-${folderIndex}-${fileIndex}-${option.value}`"
					v-on:keydown="keyDown($event, file)"
					:title="option.title"
				>
					{{option.name}}
				</label>
			</template>				
		</template>

		<template v-slot:folder>
			<template v-if="file.type==='MOVED'">
				<span :class="{'text-success' : file.selectedOption === 'LOCAL'}">{{file.folderPath}}</span>
				&nbsp;<i class="fa fa-arrow-right"></i>&nbsp;
				<span :class="{'text-warning' : file.selectedOption === 'REMOTE'}">{{file.newFolderPath}}</span>
			</template>
			<template v-else>
				{{file.folderPath}}
			</template>
		</template>

		<template v-slot:file>
			{{ file.name }}
		</template>

		<template v-slot:diff>
			<button v-if="file.type !== 'NO_CHANGE' && file.type !== 'MOVED'" class="btn btn-outline-secondary btn-sm btn-compact align-self-start ml-2" @click="showDiffDialog(file)">
				{{file.selectedOption === 'MERGE_LOCAL' || file.selectedOption === 'MERGE_REMOTE' ? 'Merge' : 'Diff'}}
			</button>
		</template>
	</GitDiffFileContainer>
</template>

<script>
import {APPLY_LOCAL_REMOTE_MAPPING} from '../../util/gitDiffConstants';
import GitDiffFileContainer from './GitDiffFileContainer';

export default {
	name: "GitDiffFile",
	props: [
		'file',
		'serviceIndex',
		'folderIndex',
		'fileIndex',
		'renderAsList'
	],
	components: {
		GitDiffFileContainer
	},
	data() {
		return {
			options:{
				NO_CHANGE : [
					{
						value: "LOCAL",
						name: "L",
						title: 'Local',
						class: "btn-local",
						selected: true
					}
				],
				CHANGED: [
					{
						value: "REMOTE",
						name:"R",
						title: 'Remote',
						class: "btn-merge",
						selected: true
					},
					{
						value: "LOCAL",
						name:"L",
						title: 'Local',
						class: "btn-local",
						selected: false
					},
					{
						value: "MERGE_LOCAL",
						name:"ML",
						title: 'Merge into local',
						class: "btn-local",
						selected: true
					},
					{
						value: "MERGE_REMOTE",
						name:"MR",
						title: 'Merge into remote',
						class: "btn-merge",
						selected: true
					}
				],
				DELETED: [
					{
						value: "DELETE",
						name:"D",
						title: 'Delete',
						class: "btn-delete",
						selected: true
					},
					{
						value: "LOCAL",
						name:"L",
						title: 'Local',
						class: "btn-local",
						selected: false
					}
				],
				NEW: [
					{
						value: "REMOTE",
						name:"N",
						title: 'New',
						class: "btn-merge",
						selected: true
					},
					{
						value: "LOCAL",
						name:"S",
						title: 'Skip',
						class: "btn-local",
						selected: false
					}
				],
				MOVED: [
					{
						value: "REMOTE",
						name:"R",
						title: 'Move',
						class: "btn-merge",
						selected: true
					},
					{
						value: "LOCAL",
						name:"S",
						title: 'Skip',
						class: "btn-local",
						selected: false
					}
				]
			}
		}
	},
	methods: {
		onSelectedOptionChange($event, file) {
			this.selectOption(file, $event.target.value);
		},
		keyDown(event, file) {
			if (event.code === 'KeyR' || event.code === 'Digit1') {
				this.selectOption(file, APPLY_LOCAL_REMOTE_MAPPING['REMOTE'][file.type]);
			} else if (event.code === 'KeyL' || event.code === 'Digit2') {
				this.selectOption(file, APPLY_LOCAL_REMOTE_MAPPING['LOCAL'][file.type]);
			} else if (event.code === 'KeyM' || event.code === 'Digit3') {
				this.selectOption(file, APPLY_LOCAL_REMOTE_MAPPING['MERGE_LOCAL'][file.type]);
			} else if (event.code === 'KeyE' || event.code === 'Digit4') {
				this.selectOption(file, APPLY_LOCAL_REMOTE_MAPPING['MERGE_REMOTE'][file.type]);
			}
		},
		selectOption(file, selectedOption) {
			this.$emit('selectOption', file, selectedOption);
		},
		showDiffDialog(file) {
			this.$emit('showDiffDialog', file);
		}
	}
}
</script>

<style scoped>
	.diff-file {
		padding: 0.15rem;
		border-radius: 0.2rem;
		border: 1px solid transparent;
	}

	.diff-file:focus-within {
		border: 1px solid #ff6200;
	}

	label.btn {
		display: inline-block !important;
	}

	.btn-group-container > .btn:not(:last-child):not(.dropdown-toggle), .btn-group-container > .btn-group-container:not(:last-child) > .btn {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	.btn-group-container > .btn {
		position: relative;
		-ms-flex: 1 1 auto;
		-webkit-box-flex: 1;
		flex: 1 1 auto;
	}

	.btn-group-container > .btn:not(:nth-child(2)), .btn-group-container > .btn-group-container:not(:nth-child(2)) > .btn {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.btn-group-container > .btn:not(:nth-child(2)), .btn-group-container > .btn-group-container:not(:nth-child(2)) {
		margin-left: -1px;
	}

	.btn-group-container {
		flex-grow: 0;
		min-width: 13rem;
	}
	.btn-check {
		position: absolute;
		clip: rect(0, 0, 0, 0);
		pointer-events: none;
	}

	.btn.btn-pill {
		min-width: 2.5rem;
		font-size: 1rem;
		padding: 0.3rem
	}

	.btn-outline-gray {
		color: #6c757d;
		border-color: #6c757d;
	}

	.btn-outline-gray:focus {
		color:#fff;
		background-color: #6c757d;
	}

	.btn-merge {
		color: #fff;
		background-color: #ff6200;
		border-color: #ff6200;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-check:focus + label.btn-merge {
		color: #fff;
		background-color: #af4604;
		border-color: #af4604;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-local {
		color: #fff;
		background-color: #35b052;
		border-color: #35b052;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-check:focus + label.btn-local{
		color: #fff;
		background-color: #1e642e;
		border-color: #1e642e;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-delete {
		color: #fff;
		background-color: #ff051e;
		border-color: #ff051e;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-check:focus + label.btn-delete {
		color: #fff;
		background-color: #85000d;
		border-color: #85000d;
		box-shadow: 0 0 0 0 transparent;
	}

	.btn-group-container .btn {
		display: inline-block;
	}

</style>